import { get } from "lodash";
import { createSelector } from "reselect";
import {
  getOperation,
  operationEnabled,
  operationPermitted,
  operationAvailable
} from "../../../utils/operations.js";

// -- QUERIES -- //

export const endpointsQuery = state => get(state, "endpoints.data", null);
export const permissionsQuery = state =>
  get(state, "account.permissions", null);

// -- SELECTORS -- //

export const selectEndpointByType = createSelector(
  [endpointsQuery],
  endpoints => entityType => {
    const endpoint = endpoints.find(
      item => get(item, "manages.@type", null) === entityType
    );

    return endpoint || null;
  }
);

export const selectOperationByTypeAndName = createSelector(
  [endpointsQuery],
  endpoints => (entityType, operationName) => {
    const endpoint = endpoints.find(
      item => get(item, "manages.@type", null) === entityType
    );

    if (endpoint) {
      return getOperation(
        operationName,
        endpoint.operations,
        endpoint.enabledOperations
      );
    }

    return false;
  }
);

export const selectOperationEnabled = createSelector(
  [endpointsQuery],
  endpoints => (entityType, operationName) => {
    const endpoint = endpoints.find(
      item => get(item, "manages.@type", null) === entityType
    );

    if (endpoint) {
      return operationEnabled(operationName, endpoint.enabledOperations);
    }

    return false;
  }
);

export const selectOperationPermitted = createSelector(
  [endpointsQuery, permissionsQuery],
  (endpoints, permissions) => (entityType, operationName) => {
    const endpoint = endpoints.find(
      item => get(item, "manages.@type", null) === entityType
    );

    if (endpoint) {
      return operationPermitted(
        operationName,
        endpoint.operations,
        permissions
      );
    }

    return false;
  }
);

export const selectOperationAvailability = createSelector(
  [endpointsQuery, permissionsQuery],
  (endpoints, permissions) => (entityType, operationName) => {
    const endpoint = endpoints.find(
      item => get(item, "manages.@type", null) === entityType
    );

    if (!endpoint) {
      console.warn(
        `no endpoint found to manage ${entityType}:${operationName}`
      );
      return {};
    }

    return operationAvailable(
      operationName,
      endpoint.operations,
      endpoint.enabledOperations,
      permissions
    );
  }
);

// using the following export pattern so we can mock more easily using jest

const endpointSelector = {
  selectEndpointByType,
  selectOperationByTypeAndName,
  selectOperationEnabled,
  selectOperationPermitted,
  selectOperationAvailability
};

export default endpointSelector;
